import React from "react";
import "./EllipsisLoader.scss";

const EllipsisLoader = () => {
  return <span className="ellipsis-loader" />;
};

export default EllipsisLoader;
